import React, { Component } from "react";
import LoanDetailsReview from "../../common/components/pageBlocks/review/loanDetailsReview";
import ModalPopUp from "../../common/components/pageBlocks/modalPopUp";
import ReviewViewDetailedBreakDown from "../../common/components/pageBlocks/review/reviewViewDetailedBreakDown";
import HdfcLogo from "../../common/components/pageBlocks/hdfcHeader";
import FormStep from "../../common/components/formStep";
import VehicleUpdateCard from "../../common/components/pageBlocks/vehicleUpdateCard";
import commonContext, { AppContext } from "../../common/context/common";
import BackContinueButton from "../../common/components/pageBlocks/backContinueButton";
import FactStatement from "../../common/components/pageBlocks/review/factStatement";
import DisbursementCard from "../../common/components/pageBlocks/review/disbursementCard";
import { leadType } from "../../app";
import { Zd10SecApis } from "../apis/zd10SecApis";

interface IProps {
    history: any;
}
interface IState {
    viewDetailedBreakdown: boolean;
}
class ReviewDetails extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    apis: Zd10SecApis;
    setLead: Function;
    steps = [
        { title: "Vehicle" },
        { title: "Loan" },
        { title: "Review", active: true },
        { title: "Personal" },
        { title: "Confirmation" },
    ];
    constructor(props: IProps) {
        super(props);
        this.state = {
            viewDetailedBreakdown: false,
        };
    }
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.apis = (this.context as AppContext).apis as Zd10SecApis;
        this.lead = (this.context as AppContext).lead as leadType;
        this.setLead = (this.context as AppContext).setLead;
        const apiData = await this.apis.getReviewDetails(this.lead);
        // if (apiData.error.error) {
        // }
        this.setLead(apiData.result);
    }
    render() {
        return (
            <>
                <div className="wrapper">
                    <HdfcLogo />
                    <section className="review-wrap mt-110">
                        <div className="container mx-auto px-5">
                            <FormStep steps={this.steps} />
                            <FactStatement />
                            <VehicleUpdateCard />
                            <LoanDetailsReview />
                            <DisbursementCard />
                            <div className="relative w-full">
                                <div className="text-left">
                                    <a
                                        href="javascript:;"
                                        title="View Detailed Breakdown"
                                        className="openSans-SemiBold blue-link-color no-underline hover:underline hover:text-black text-base sm:text-lg md:text-xl transition-all modal-open"
                                        data-toggle="modal"
                                        data-target="breakDownModal"
                                        onClick={() =>
                                            this.setState({
                                                viewDetailedBreakdown: true,
                                            })
                                        }
                                    >
                                        View Detailed Breakdown
                                    </a>
                                </div>
                            </div>
                            <form
                                onSubmit={() =>
                                    this.props.history.push("/personal-details")
                                }
                            >
                                <div className="flex flex-wrap flex-col-reverse sm:flex-row my-8 items-center w-full">
                                    <BackContinueButton backPath="loan-details" />
                                </div>
                            </form>
                        </div>
                    </section>

                    {/* <!-- View Detailed Breakdown Popup Start --> */}
                    {this.state.viewDetailedBreakdown ? (
                        <ModalPopUp
                            onclickhandler={() =>
                                this.setState({ viewDetailedBreakdown: false })
                            }
                        >
                            <ReviewViewDetailedBreakDown />
                        </ModalPopUp>
                    ) : (
                        ""
                    )}
                    {/* <!-- View Detailed Breakdown Popup End -->  */}
                </div>
            </>
        );
    }
}

export default ReviewDetails;
